import type { CourseColor } from "@shared/models/colors"

export { SECTION_COLOR_LIGHT_MAP, SECTION_COLOR_MAP } from "@tiptap-content/util/colors"

/**
 * Maps from course color names to their rendered color strings.
 * JS copy of the --course-color-* values from colors.css.
 */
export const COURSE_COLOR_MAP: Record<CourseColor, string> = {
  yellow: "hsl(48, 86%, 64%)",
  green: "hsl(91, 63%, 65%)",
  turquoise: "hsl(156, 68%, 60%)",
  cyan: "hsl(183, 69%, 53%)",
  blue: "hsl(206, 78%, 73%)",
  purple: "hsl(290, 44%, 75%)",
  pink: "hsl(342, 89%, 75%)",
  coral: "hsl(9, 88%, 70%)",
  "muted-yellow": "hsl(50, 55%, 56%)",
  "muted-green": "hsl(90, 39%, 56%)",
  "muted-turquoise": "hsl(150, 38%, 56%)",
  "muted-cyan": "hsl(179, 35%, 50%)",
  "muted-blue": "hsl(205, 31%, 59%)",
  "muted-purple": "hsl(283, 17%, 59%)",
  "muted-pink": "hsl(341, 32%, 56%)",
  "muted-coral": "hsl(5, 36%, 54%)",
}
